import { Constants } from '.'

const initialState = {
  get: {
    isRequest: true,
    payload: {},
    error: {}
  },
  delete: {
    isRequest: true,
    payload: {},
    error: {}
  }
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case Constants.NOTIFICATION_GET:
      return {
        ...state,
        get: {
          ...state.get
        }
      }

    case Constants.NOTIFICATION_GET_SUCCESS:
      return {
        ...state,
        get: {
          ...state.get,
          isRequest: false,
          payload: action.payload
        }
      }

    case Constants.NOTIFICATION_GET_FAILURE:
      return {
        ...state,
        get: {
          ...state.get,
          isRequest: false,
          error: action.error
        }
      }

    case Constants.NOTIFICATION_DELETE:
      return {
        ...state,
        delete: {
          ...state.delete
        }
      }

    case Constants.NOTIFICATION_DELETE_SUCCESS:
      return {
        ...state,
        delete: {
          ...state.delete,
          isRequest: false,
          payload: action.payload
        }
      }

    case Constants.NOTIFICATION_DELETE_FAILURE:
      return {
        ...state,
        delete: {
          ...state.delete,
          isRequest: false,
          error: action.error
        }
      }

    default:
      return state
  }
}
